import { defineComponent as i, createElementBlock as n, openBlock as l, mergeProps as r, unref as o, createElementVNode as u, createCommentVNode as p, normalizeClass as m, renderSlot as f } from "vue";
import a from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Check/check.js";
import { useOUIAProps as h } from "../../helpers/ouia.js";
const k = ["checked"], C = /* @__PURE__ */ i({
  name: "PfMenuToggleCheckbox",
  inheritAttrs: !1,
  __name: "MenuToggleCheckbox",
  props: {
    checked: { type: [Boolean, null] },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(c) {
    const t = c, d = h({ id: t.ouiaId, safe: t.ouiaSafe });
    return (e, b) => (l(), n("label", r(o(d), {
      class: [o(a).check, { [o(a).modifiers.standalone]: !e.$slots.default }]
    }), [
      u("input", r(e.$attrs, {
        ref: (s) => s ? s.indeterminate = e.checked === null : void 0,
        class: o(a).checkInput,
        type: "checkbox",
        checked: !!e.checked
      }), null, 16, k),
      e.$slots.default ? (l(), n("span", {
        key: 0,
        class: m(o(a).checkLabel),
        "aria-hidden": "true"
      }, [
        f(e.$slots, "default")
      ], 2)) : p("", !0)
    ], 16));
  }
});
export {
  C as default
};
